import * as React from "react";
import { Table,Input, message} from "antd";
import { connect } from "react-redux";
//import moment from "moment";
const Search = Input.Search;

interface ICostlistProps {
  id:any;
  costlist:any;
  changecost:any;
}

// 修改
class Costlist extends React.Component<ICostlistProps, any> {
  state = {
     list:[],
     coin:'',
  };
  constructor(props: ICostlistProps) {
    super(props);
  }

  componentDidMount() {
    this.costlist();     
  }

  costlist = () =>{
    const param: any = {
      id: this.props.id
    }; 
    this.props.costlist({
      ...param,
      callback: (data) => {
        this.setState({
           list: data.logs,
           coin: data.coin_sign,
        });
      }
     });    
  }

  search= (value,e) =>{
    const param: any = {
      id: this.props.id,
      val:value
    }; 
    this.props.changecost({
      ...param,
      callback: (data) => {
         console.log(data)
         if(data.res.code == '1001'){
            message.error(data.res.msg);
         }else{
          this.costlist();
         }
      }
     });    
  }

  render() {
    const dataSource = this.state.list;
    
    const columns = [{
      title: '时间',
      dataIndex: 'create_time',
      key:'create_time',
      className:'th',
      width: 200,
    }, {
      title: '操作人',
      dataIndex: 'operator',
      key:'operator',
      className:'th',
      width: 200,
    }, {
      title: '内容',
      dataIndex: 'logs',
      key:'logs',
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
                <div dangerouslySetInnerHTML={{__html: row.logs}} />
          </React.Fragment>
        );
      }
    }];

    
    return (
      <React.Fragment>
           <div className="from-email"> 
                   <p className="cost">
                       <label>订单成本({this.state.coin}):</label>
                       <Search   enterButton='提交' onSearch={this.search}/>
                   </p>
                   <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
           </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    costlist: dispatch.orderDetails.costlist,
    changecost: dispatch.orderDetails.changecost
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Costlist);
